import { render, staticRenderFns } from "./RevisionNotes.vue?vue&type=template&id=55d0acee&scoped=true"
import script from "./RevisionNotes.vue?vue&type=script&lang=js"
export * from "./RevisionNotes.vue?vue&type=script&lang=js"
import style0 from "./RevisionNotes.vue?vue&type=style&index=0&id=55d0acee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0acee",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QExpansionItem,QCard,QCardSection});
